// simulator todo - this component needs more refactoring
import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import cx from "classnames";
import confetti from "canvas-confetti";
//@ts-ignore
import { Message } from "ai/react";
import {
  Badge,
  Kbd,
  Button,
  Spinner,
  Tooltip as RadixTooltip,
  IconButton,
  Flex,
  Text,
  Switch,
} from "@radix-ui/themes";
import { Tooltip } from "@/components/shared/tooltip";
import { Plus, ThumbsDown, ThumbsUp } from "@geist-ui/icons";
import { Cross1Icon, InfoCircledIcon, UploadIcon } from "@radix-ui/react-icons";
import { toast } from "sonner";
import { Loader2Icon } from "lucide-react";
import { useWorkspace } from "@/routes/simulator/context/wrokspace"; // simulator todo - replace
import { Instruction as OldInstruction } from "@/routes/simulator/types"; // simulator todo - should not be here
import { useChangeStatusInteractionInTraining } from "@/api/training";
import { useSimulatorTracking } from "@/routes/simulator/useSimulatorTracking";
import { posthogTrackEvent, SimulatorEvents } from "@/assets/posthog";
import { useGetSkills } from "@/v2/entities/skill/useGetSkills";
import { useUploadFile } from "@/api/file";

import {
  SimulatorWrapperContextType,
  useSimulator,
} from "../../context/SimulatorWrapper";
import { newReleasePolicyToInstructionJson } from "../../context/v1Helper";
import { useChat } from "../../context/ChatWrapper";
import { InputType } from "../input";
import ImproveButton from "../improve";
import { Messages } from "../messages";
import { TrainingSessionEventType } from "@/v2/entities/training-session-event/TrainingSessionEvent.model";

import { useBadFeedback } from "./api"; // simulator todo - replace
import styles from "./styles.module.scss";
import { validateSendMessageEvent } from "./chat.types";
import { Version } from "@/v2/entities/release/Release.model";
import { Navigate } from "react-router-dom";
import { ChatInput } from "./ChatInput";
import { SimulatorActionsButton } from "./SimulatorActionsButton";
import { AddToRegressionSetDialog } from "./add-to-regression-set-dialog";
import { useReleaseConversationApi } from "@/v2/entities/release-conversation/ReleaseConversation.api";

interface ChatProps
  extends Omit<SimulatorWrapperContextType, "currentRelease"> {
  currentRelease: Version;
  onCloseSimulator?: (isDone?: boolean) => void;
  setIsLoadingMessages: Dispatch<SetStateAction<boolean>>;
  onCreateSnippetClick?: () => void;
}

export function Chat({
  onCloseSimulator,
  setIsLoadingMessages,
  topics,
  simulator,
  currentRelease,
  upsertConversation,
  createInstruction,
  createPrerequisite,
  handleBrief,
  reportTrainingSessionEvent,
  onCreateSnippetClick,
  descriptionOverrides,
}: ChatProps) {
  const {
    trackInstructionAdded,
    trackFeedbackProvided,
    trackTrainingDataAdded,
  } = useSimulatorTracking();
  const isInstructionChanged = useRef<boolean>(false);
  const { workspace } = useWorkspace();

  const [selectedTicket, setSelectedTicket] = useState<string | null>(null);
  const [isReload, setReload] = useState(false);
  const [isRedrafting, setRedrafting] = useState(false);
  const [isAddToRegressionSetOpen, setIsAddToRegressionSetOpen] =
    useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const fParam = searchParams.get("f");

  const {
    conversationId,
    messages,
    input,
    handleInputChange,
    handleSubmit,
    append,
    reload,
    setInput,
    setMessages,
    isLoading,
    isProcessingMessage,
    isGeneratingTopic,
    setProcessingMessage,
    ErrorModal,
    messageSources,
    setMessageSources,
    handleTopicAssignment,
    selectedTopic,
    baseNewSession,
    messagesContextExport,
    handleAddMessage,
    releaseConversationId,
    selectedTopicReason,
    includeDrafts,
    setIncludeDrafts,
  } = useChat();

  const { data: skills } = useGetSkills();

  const isChat = useMemo(
    () => simulator?.channel === "autonomous_quackchat",
    [simulator?.channel]
  );
  const [subTopic] = useState(null);
  const [textareaValue, setTextareaValue] = useState("");
  const [type, __setType] = useState<InputType>("none");

  const setType = (newType: InputType) => {
    __setType(newType);
  };

  const [files, setFiles] = useState<File[]>([]);

  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const trackingData = {
    source: "simulator-autopilot",
    channel: simulator?.channel,
    topic: selectedTopic?.topic,
    subTopic,
  };

  const { mutateAsync: changeStatusInteractionInTraining } =
    useChangeStatusInteractionInTraining();

  useEffect(() => {
    function handleWindowMessage(event: MessageEvent) {
      const eventData = validateSendMessageEvent(event.data);
      if (eventData) {
        const data = eventData.data;

        switch (eventData.type) {
          case "reload":
          default:
            break;
        }
      }
    }

    window.addEventListener("message", handleWindowMessage);

    return () => {
      window.removeEventListener("message", handleWindowMessage);
    };
  }, [isReload]);

  const handleSuccessFeedback = async () => {
    handleResetConversation("POSITIVE");
    confetti({
      particleCount: 100,
      spread: 100,
      origin: { y: 0.5, x: 0.4 },
    });
  };

  const handleNegativeFeedback = async () => {
    handleResetConversation("NEGATIVE");
  };

  const handleFileUpload = useCallback(() => {
    const input = document.createElement("input");
    input.type = "file";
    input.onchange = (event) => {
      event.preventDefault();
      event.stopPropagation();
      const file = (event.target as HTMLInputElement).files?.[0];
      if (file) {
        setFiles((prevFiles) => [...prevFiles, file]);
      }
    };
    input.click();
  }, []);

  const { updateReleaseConversationFeedback } = useReleaseConversationApi();

  const uploadFileMutation = useUploadFile();
  const [isUploadingFiles, setIsUploadingFiles] = useState(false);

  const uploadFile = async (file: File) => {
    const result = await uploadFileMutation.mutateAsync(
      {
        file,
      },
      {
        onError: (e) => {
          toast.error("Error uploading file");
        },
      }
    );

    reportTrainingSessionEvent(
      TrainingSessionEventType.UPLOAD_FILE,
      {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type,
      },
      {},
      {
        topicId: selectedTopic?.id,
        releaseConversationId: conversationId ?? undefined,
      }
    );

    return result;
  };

  const oldStructureInstruction = useMemo(() => {
    return newReleasePolicyToInstructionJson(
      currentRelease,
      topics ?? [],
      selectedTopic?.id
    );
  }, [currentRelease, topics, selectedTopic?.id]);

  const handleFormSubmission = useCallback(async () => {
    switch (type) {
      case "none":
        setProcessingMessage(true);

        if (messages.length === 0) {
          await handleTopicAssignment(textareaRef?.current?.value ?? "", descriptionOverrides);
          await new Promise((resolve) => setTimeout(resolve, 300)); // Sleep for 0.3 seconds
        }

        setProcessingMessage(true);
        trackTrainingDataAdded(conversationId?.toString(), "inquiry");

        const filesValue = [...files];

        const shouldUploadFiles = filesValue.length > 0;

        if (shouldUploadFiles) {
          try {
            setIsUploadingFiles(true);
            const uploadFilePromises = files.map((file) => uploadFile(file));
            const data = await Promise.allSettled(uploadFilePromises);
            const successfulUploads = data.filter(
              (x) => x.status === "fulfilled"
            );
            const failedUploads = data.filter((x) => x.status === "rejected");

            if (failedUploads.length > 0) {
              console.warn("Some file uploads failed:", failedUploads);
              if (failedUploads.length === data.length) {
                toast.error("Failed to upload files. Please try again.");
                setProcessingMessage(false);
                return;
              }
            }

            if (successfulUploads.length > 0) {
              const messageContent = textareaRef.current?.value ?? "";
              const fileLinks = successfulUploads.map(
                (x: any) => (x.value as any).data.downloadableLink
              );

              append({
                id: `user-${Date.now()}`,
                role: "user",
                content: `${messageContent} 

Review the following files: ${fileLinks.join(`
`)}`,
              });
            } else {
              // If all file uploads failed, still send the message without files
              handleSubmit();
            }

            setFiles([]);
            setInput("");
          } catch (error) {
            console.error("Error uploading files:", error);
            toast.error("Error uploading files. Please try again.");
            setProcessingMessage(false);
          } finally {
            setIsUploadingFiles(false);
          }
        } else {
          handleSubmit();
        }

        break;
      case "instruction":
        const inputValue = textareaRef?.current?.value ?? "";

        trackInstructionAdded(inputValue);
        createInstruction(inputValue, selectedTopic?.id ?? 0);

        setTimeout(() => {
          setTextareaValue("");
          setType("none");
          textareaRef!.current!.style.height = "24px";
        }, 300);

        break;
      case "feedback":
        handleResetConversation("NEGATIVE", textareaRef?.current?.value ?? "");

        setTimeout(() => {
          setTextareaValue("");
          setType("none");
          textareaRef!.current!.style.height = "24px";
        }, 300);

        break;
    }
  }, [
    type,
    messages.length,
    files,
    setProcessingMessage,
    setFiles,
    setInput,
    setTextareaValue,
    setType,
    handleTopicAssignment,
    upsertConversation,
    uploadFile,
    append,
    handleSubmit,
    createInstruction,
    trackingData,
    currentRelease?.id,
    simulator?.id,
    textareaRef,
    descriptionOverrides,
  ]);

  const handleRemoveFile = useCallback((file: File) => {
    setFiles((prevFiles) => prevFiles.filter((prevFile) => prevFile !== file));
  }, []);

  const { mutateAsync: mutateBadFeedback } = useBadFeedback({
    isChat,
  });

  const handleBadFeedback = async ({
    badFeedback,
    instructions,
    topic,
    subTopic,
    messages,
    setChatLoading,
  }: {
    messages: Message[];
  } & any): Promise<string> => {
    setRedrafting(true);

    try {
      const res = await mutateBadFeedback({
        tenant: workspace ?? "",
        instructions: [
          ...instructions.filter(
            (i: OldInstruction) =>
              i.type === "general" || i.topic?.trim() === topic?.trim()
          ),
          {
            topic,
            subTopic,
            type: "manual",
            content: `
          The last response was:
          ${messages[messages.length - 1].content}
          YOU MUST PROVIDE AN ALTERNATIVE RESPONSE, IT CAN'T BE THE SAME AS THE LAST RESPONSE
          this response isn't good enough fix by following feedback: ${badFeedback}
          `,
          },
        ],
        topic,
        subTopic,
        skills,
        simulatorId: simulator?.id,
        releaseId: currentRelease?.id ?? 0,
        topicId: selectedTopic?.id,
        seperateGoodFeedback: simulator?.seperateGoodFeedback,
        customToneOfVoice: currentRelease?.customToneOfVoice,
        messages: [...messages.slice(0, -1)],
      });

      setRedrafting(false);

      return res.text || "I'm sorry, I will escalate this to a human agent";
    } catch (e) {
      setRedrafting(false);
      return "I'm sorry, I will escalate this to a human agent";
    }
  };

  const handleResetConversation = async (
    feedback?: "NEGATIVE" | "POSITIVE",
    feedbackComment?: string
  ) => {
    const baseProps = {
      releaseId: currentRelease?.id,
      releaseConversationId: releaseConversationId ?? 0,
      topicId: selectedTopic?.id,
      simulatorId: simulator?.id,
      isAgent: false,
    };

    if (feedback === "NEGATIVE" && feedbackComment) {
      const res = await handleBadFeedback({
        tenant: workspace ?? "",
        instructions: oldStructureInstruction,
        topic: selectedTopic?.topic,
        subTopic,
        messages,
        badFeedback: feedbackComment,
        setChatLoading: setRedrafting,
      });

      trackFeedbackProvided("negative", messages[messages.length - 1]?.content);

      await upsertConversation({
        ...baseProps,
        feedback,
        feedbackComment: "",
      });

      setMessages([
        ...messages.slice(0, -1),
        { id: String(Date.now()), content: res, role: "assistant" },
      ]);

      return;
    }

    if (feedback === "POSITIVE") {
      await updateReleaseConversationFeedback(conversationId ?? 0, {
        feedback: "POSITIVE",
        feedbackComment: feedbackComment ?? "",
      });
      baseNewSession();
      return;
    }

    if (feedback === "NEGATIVE") {
      const latestUserMessage = Array.isArray(messages)
        ? messages
            .slice()
            .reverse()
            .find((m) => m?.role === "user")?.content || ""
        : "";

      await upsertConversation({
        ...baseProps,
        feedback,
        comment: latestUserMessage,
        feedbackComment: feedbackComment ?? "",
      });

      setTimeout(() => baseNewSession(), 1000);
      return;
    }

    baseNewSession();

    if (feedback && !feedbackComment) {
      onCloseSimulator?.(feedback === "POSITIVE");
    }
  };

  const [inputValue, handleInputValueChange] =
    type === "none"
      ? [input, handleInputChange]
      : [
          textareaValue,
          (
            e:
              | React.ChangeEvent<HTMLInputElement>
              | React.ChangeEvent<HTMLTextAreaElement>
          ) => {
            isInstructionChanged.current = true;
            setTextareaValue(e.target.value);
          },
        ];

  const handleEditMessage = (message: string) => {
    upsertConversation({
      releaseId: currentRelease?.id,
      comment: message,
      releaseConversationId: conversationId ?? 0,
      topicId: selectedTopic?.id,
      simulatorId: simulator?.id,
      isAgent: true,
    });

    const newMessages = [
      ...messages.slice(0, -1),
      {
        content: message,
        role: "assistant" as const,
        id: messages[messages.length - 1]?.id,
      },
    ];
    setMessages(newMessages);
  };

  useEffect(() => {
    setIsLoadingMessages(
      isProcessingMessage ||
        isLoading ||
        isGeneratingTopic ||
        isUploadingFiles ||
        isRedrafting
    );
  }, [
    isProcessingMessage,
    isLoading,
    isGeneratingTopic,
    setIsLoadingMessages,
    isUploadingFiles,
    isRedrafting,
  ]);

  useEffect(() => {
    return () => {
      baseNewSession();
    };
  }, []);

  const handleIngestionOfContext = (
    context: string,
    type: "instruction" | "brief" | "prerequisite"
  ) => {
    if (!selectedTopic?.id) {
      toast.error("Something is wrong, topic is not set");
      return;
    }
    setReload(true);

    switch (type) {
      case "instruction":
        createInstruction(context, selectedTopic?.id);
        break;
      case "brief":
        const brief = currentRelease?.topicReleasePolicies?.find(
          (topic) => topic.topicId === selectedTopic?.id
        )?.brief;

        const newBrief = brief ? brief + "\n\n****\n\n" + context : context;
        handleBrief(newBrief, selectedTopic?.id);
        break;
      case "prerequisite":
        createPrerequisite(context, selectedTopic?.id);
        break;
    }
  };

  const latestConversationIdInDB = useMemo(() => {
    if (!currentRelease?.releaseConversations?.length) {
      return null;
    }
    return currentRelease.releaseConversations.reduce((latest, current) => {
      return current.id > latest.id ? current : latest;
    });
  }, [currentRelease]);

  const handleAddToRegressionSet = useCallback(() => {
    if (!latestConversationIdInDB?.id) {
      toast.error("No conversation available to add");
      return;
    }
    setIsAddToRegressionSetOpen(true);
  }, [latestConversationIdInDB]);

  if (topics?.length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.messagesContainer}>
          <div className={styles.topContainer}>
            <Flex
              align="center"
              justify="between"
              width="100%"
              px="3"
              py="2"
              gap="3"
              style={{
                borderBottom: "1px solid var(--gray-6)",
                backgroundColor: "var(--color-background)",
              }}
            >
              {(isGeneratingTopic ||
                messages.length ||
                selectedTopic?.topic) && (
                <Button
                  onClick={() => handleResetConversation()}
                  size={"2"}
                  color="gray"
                  variant="outline"
                  disabled={
                    isGeneratingTopic || isProcessingMessage || !messages.length
                  }
                >
                  <Plus />
                  New Session
                </Button>
              )}

              <Flex
                align="center"
                gap="2"
                px="2"
                py="1"
                style={{
                  borderRadius: "6px",
                  border: includeDrafts
                    ? "2px solid var(--blue-9)"
                    : "2px solid var(--gray-6)",
                  backgroundColor: includeDrafts
                    ? "var(--blue-a3)"
                    : "transparent",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  marginLeft: "auto",
                }}
              >
                <Tooltip>
                  <Tooltip.Trigger>
                    <IconButton variant="ghost" size="1" color="gray">
                      <InfoCircledIcon height={14} width={14} />
                    </IconButton>
                  </Tooltip.Trigger>
                  <Tooltip.Content>
                    <div style={{ maxWidth: "250px", padding: "4px" }}>
                      <Text size="2">
                        For training purposes only - Allow this agent to access
                        draft articles from the knowledge base.
                      </Text>
                    </div>
                  </Tooltip.Content>
                </Tooltip>
                <Text size="2" weight="medium">
                  Include Drafts
                </Text>
                <Switch
                  size="1"
                  checked={includeDrafts}
                  onCheckedChange={setIncludeDrafts}
                />
              </Flex>
            </Flex>
          </div>

          {selectedTopic?.topic && (
            <div className={styles.badgesContainer}>
              <Badge className={styles.primary}>
                {selectedTopic?.topic}
                {selectedTopicReason && (
                  <Tooltip>
                    <Tooltip.Trigger>
                      <IconButton variant="soft" size="1" color="gray">
                        <InfoCircledIcon height={16} width={16} />
                      </IconButton>
                    </Tooltip.Trigger>
                    <Tooltip.Content>
                      <div className=" w-96 px-2 gap-1">
                        <Text className=" text-sm">
                          Reason for choosing this topic:
                        </Text>
                        <Text className=" text-xs">{selectedTopicReason}</Text>
                      </div>
                    </Tooltip.Content>
                  </Tooltip>
                )}
              </Badge>
            </div>
          )}
          <Messages
            messages={messages}
            isLoading={isLoading}
            isLoadingChat={isProcessingMessage}
            handleEditMessage={handleEditMessage}
            messagesContextExport={messagesContextExport}
            trackingData={trackingData}
            isRedrafting={isRedrafting}
            isGeneratingTopic={isGeneratingTopic}
            isProcessingMessage={isProcessingMessage}
            selectedTopic={selectedTopic}
          />
        </div>

        {(fParam !== "copilot" ||
          (fParam === "copilot" && selectedTicket !== null)) && (
          <form
            onSubmit={(event) => {
              event.preventDefault();
              handleFormSubmission();
            }}
          >
            <div className={styles.inputContainer}>
              <div className={styles.feedbackContainer}>
                {messages.length > 1 && (
                  <>
                    <Text size="1">Rate the conversation</Text>
                    <div>
                      <RadixTooltip
                        content={`Teach Quack that this answer is "verified"`}
                      >
                        <button
                          type="button"
                          className={cx(styles.btn, styles.positive)}
                          onClick={handleSuccessFeedback}
                        >
                          <ThumbsUp />
                        </button>
                      </RadixTooltip>
                      <RadixTooltip
                        content={`Teach Quack that this answer is "verified"`}
                      >
                        <ImproveButton
                          handleIngestionOfContext={handleIngestionOfContext}
                          latestConversationIdInDB={latestConversationIdInDB}
                          topicIdRef={selectedTopic?.id ?? null}
                          latestMessage={messages[messages.length - 1]?.content}
                        />
                      </RadixTooltip>
                      <RadixTooltip
                        content={`Let Quack know what was wrong, or just count its as a bad answer`}
                      >
                        <button
                          type="button"
                          className={cx(styles.btn, styles.negative)}
                          onClick={handleNegativeFeedback}
                          disabled={
                            isLoading || isProcessingMessage || isRedrafting
                          }
                        >
                          {isLoading || isProcessingMessage || isRedrafting ? (
                            <Spinner />
                          ) : (
                            <ThumbsDown />
                          )}
                        </button>
                      </RadixTooltip>
                    </div>
                  </>
                )}
              </div>

              <ChatInput
                channel={simulator?.channel}
                ref={textareaRef}
                type={type}
                value={inputValue}
                loading={isProcessingMessage || isUploadingFiles}
                disableInstructions={selectedTopic === null}
                messagesLength={messages.length}
                setType={setType}
                handleInputChange={handleInputValueChange}
                handleResetConversation={handleResetConversation}
                handleSubmit={handleFormSubmission}
              />

              <div className={styles.bottomBar}>
                <Flex gap={"2"} align={"center"} minHeight={"20px"}>
                  <RadixTooltip
                    content="You can upload files up to 5mb"
                    collisionPadding={10}
                  >
                    <IconButton
                      size={"1"}
                      color="gray"
                      variant="ghost"
                      type="button"
                      onClick={handleFileUpload}
                      disabled={isUploadingFiles}
                    >
                      {isUploadingFiles ? (
                        <Loader2Icon
                          className="animate-spin"
                          width="15"
                          height="15"
                        />
                      ) : (
                        <UploadIcon width="15" height="15" />
                      )}
                    </IconButton>
                  </RadixTooltip>

                  {files.map((file) => (
                    <Badge key={file.name} size="1">
                      {isUploadingFiles ? (
                        <Loader2Icon
                          className="animate-spin"
                          width="10"
                          height="10"
                        />
                      ) : (
                        file.name.slice(0, 10) + "..."
                      )}
                      <IconButton
                        size="1"
                        color="gray"
                        variant="ghost"
                        onClick={() => handleRemoveFile(file)}
                        disabled={isUploadingFiles}
                      >
                        <Cross1Icon width="10" height="10" />
                      </IconButton>
                    </Badge>
                  ))}
                </Flex>

                <Flex gap="2" align="center">
                  <Button
                    type={"button"} // important - otherwise form will submit on click
                    color={"gray"}
                    variant={"ghost"}
                    highContrast
                    size={"1"}
                    onClick={() => {
                      posthogTrackEvent({
                        event: SimulatorEvents.MESSAGE_SENT,
                        properties: {
                          messageLength: 0,
                          messageType: "regenerate",
                          timestamp: new Date().toISOString(),
                        },
                      });
                      reportTrainingSessionEvent(
                        TrainingSessionEventType.MESSAGE_REGENERATED,
                        {
                          currentMessage:
                            messages[messages.length - 1]?.content,
                        },
                        {},
                        {
                          topicId: selectedTopic?.id,
                          releaseConversationId:
                            latestConversationIdInDB?.id ?? undefined,
                        }
                      );
                      setProcessingMessage(true);
                      reload();
                    }}
                  >
                    <Kbd size={"3"}>R</Kbd>
                    <Text size="1">Regenerate</Text>
                  </Button>

                  <SimulatorActionsButton
                    onCreateSnippetClick={onCreateSnippetClick}
                    onRegenerateClick={() => {
                      posthogTrackEvent({
                        event: SimulatorEvents.MESSAGE_SENT,
                        properties: {
                          messageLength: 0,
                          messageType: "regenerate",
                          timestamp: new Date().toISOString(),
                        },
                      });
                      reportTrainingSessionEvent(
                        TrainingSessionEventType.MESSAGE_REGENERATED,
                        {
                          currentMessage:
                            messages[messages.length - 1]?.content,
                        },
                        {},
                        {
                          topicId: selectedTopic?.id,
                          releaseConversationId:
                            latestConversationIdInDB?.id ?? undefined,
                        }
                      );
                      setProcessingMessage(true);
                      reload();
                    }}
                    onAddToRegressionSet={handleAddToRegressionSet}
                  />
                </Flex>
              </div>
            </div>
          </form>
        )}
      </div>
      {ErrorModal()}
      {latestConversationIdInDB && simulator?.id && (
        <AddToRegressionSetDialog
          open={isAddToRegressionSetOpen}
          onOpenChange={setIsAddToRegressionSetOpen}
          releaseConversationId={latestConversationIdInDB.id}
          simulatorId={simulator.id}
        />
      )}
    </>
  );
}

interface ChatReleaseGuradProps {
  onCloseSimulator?: (isDone?: boolean) => void;
  setIsLoadingMessages: Dispatch<SetStateAction<boolean>>;
  onCreateSnippetClick?: () => void;
}

export function ChatReleaseGurad(props: ChatReleaseGuradProps) {
  const simulatorValue = useSimulator();
  const { currentRelease, isLoadingCurrentRelease, currentReleaseError } =
    simulatorValue;

  if (currentReleaseError) {
    toast.error("Something is wrong, release is not set");
    return <Navigate to="/" />;
  }

  if (isLoadingCurrentRelease || currentRelease == null) {
    return (
      <Flex
        justify={"center"}
        align={"center"}
        height={"100%"}
        width={"100%"}
        direction={"column"}
        gap={"2"}
      >
        <Text size="3" weight="medium" color="gray" highContrast>
          Loading Simulator
        </Text>
        <Spinner size="3" />
      </Flex>
    );
  }

  return (
    <Chat {...props} {...simulatorValue} currentRelease={currentRelease} />
  );
}
